// @ts-check

import {
  GET_PREDICTIVE_ROUTING,
  GET_PREDICTIVE_ROUTING_CONFIG,
  CREATE_PREDICTIVE_ROUTING_CONFIG,
  UPDATE_PREDICTIVE_ROUTING_CONFIG,
  DELETE_PREDICTIVE_ROUTING_CONFIG,
  GET_PREDICTIVE_ROUTING_CONFIG_REFERENCES,
  CONVERT_PREDICTIVE_ROUTING_CONFIG_TO_ADVANCED,
  CONVERT_PREDICTIVE_ROUTING_CONFIG_TO_BASIC
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getPredictiveRoutingStatus = state => state.status[getActionStatusName(GET_PREDICTIVE_ROUTING)] || {};
export const getPredictiveRoutingConfigStatus = state => state.status[getActionStatusName(GET_PREDICTIVE_ROUTING_CONFIG)] || {};
export const createPredictiveRoutingConfigStatus = state => state.status[getActionStatusName(CREATE_PREDICTIVE_ROUTING_CONFIG)] || {};
export const updatePredictiveRoutingConfigStatus = state => state.status[getActionStatusName(UPDATE_PREDICTIVE_ROUTING_CONFIG)] || {};
export const deletePredictiveRoutingConfigStatus = state => state.status[getActionStatusName(DELETE_PREDICTIVE_ROUTING_CONFIG)] || {};
export const getPredictiveRoutingConfigReferencesStatus = state => state.status[getActionStatusName(GET_PREDICTIVE_ROUTING_CONFIG_REFERENCES)] || {};
export const convertPredictiveRoutingConfigToAdvancedStatus = state => state.status[getActionStatusName(CONVERT_PREDICTIVE_ROUTING_CONFIG_TO_ADVANCED)] || {};
export const convertPredictiveRoutingConfigToBasicStatus = state => state.status[getActionStatusName(CONVERT_PREDICTIVE_ROUTING_CONFIG_TO_BASIC)] || {};
